import {AgGridReact} from "ag-grid-react";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../../../utils/ag-grid-columns-utils.js";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import React from "react";
import Button from "../../../../../../components/button/button.jsx";
import {FaTrash} from "react-icons/fa";
import {useFormContext} from "react-hook-form";
import {Card} from "../../../../../../components/card/card.jsx";

const IntegrationsTable = ({integrationData = [], onSelect}) => {
    const {watch, setValue} = useFormContext();
    const integrations = watch("integrations") ?? [];

    const removeItem = (item) => {
        const newData = integrations.filter(el => Number(el.id) !== Number(item.id) || Number(el.vmsId) !== Number(item.vmsId));
        setValue("integrations", newData, {shouldDirty: true});
    }

    const updateOffset = ({data, newValue}) => {
        const newData = integrations.map(item =>
            Number(item.id) === Number(data.id) && Number(item.vmsId) === Number(data.vmsId)
                ? {...item, offset: newValue}
                : item
        );

        setValue("integrations", newData, {shouldDirty: true});
    }

    const columnDefs = [
        {headerName: "ID", field: "id", tooltipField: "id", width: 60},
        {headerName: "VMS", field: "vmsName", tooltipField: "vmsName", flex: 1},
        {headerName: "Nome", field: "name", tooltipField: "name", flex: 1},
        {
            headerName: "Correção",
            field: "offset",
            tooltipField: "offset",
            width: 110,
            editable: true,
            singleClickEdit: true,
            cellEditor: "agNumberCellEditor",
        },
        {
            width: 60,
            cellRenderer: (params) =>
                <div className="flex items-center justify-center h-full">
                    <Button target="danger" type="button" onClick={(event) => { event.stopPropagation(); removeItem(params.data); }}><FaTrash/></Button>
                </div>
        },
    ]

    return (
        <Card>
            <Card.Header>
                <Card.Title>Câmeras associadas</Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="max-h-[400px] flex flex-col">
                <AgGridReact
                    tooltipShowDelay={400}
                    tooltipShowMode='whenTruncated'
                    rowData={integrationData ?? []}
                    domLayout="autoHeight"
                    columnDefs={columnDefs}
                    defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
                    animateRows={false}
                    suppressCellFocus={true}
                    stopEditingWhenCellsLoseFocus={true}
                    onCellValueChanged={updateOffset}
                    onRowClicked={({data}) => onSelect?.(data)}
                    gridOptions={{localeText: aggridUtils.localization()}}
                    theme={aggridUtils.generalTheme({rowHeight: 40})}
                />
                </div>
            </Card.Body>
        </Card>
    )
}

export default IntegrationsTable;
